import {
  withDatasourceCheck,
  Placeholder,
  TextField,
  Field,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'src/hooks/helpers';
import { useState, useEffect } from 'react';
import AccordionItem from 'components/Sections/Accordion/AccordionItem';
import AccordionItems from 'components/Sections/Accordion/AccordionItems';

type FieldsType = {
  items: Array<{
    fields: {
      title: TextField;
      description: TextField;
      items?: Array<{
        fields: {
          // title: TextField;
          // description: TextField;
          editionId: Field<string>;
        };
        template: string;
      }>;
    };
  }>;
};

type AccordionProps = ComponentProps & {
  fields: FieldsType;
  hideTitle: boolean;
  articleBody?: boolean;
};

const Accordion = ({ fields, rendering, hideTitle }: AccordionProps): JSX.Element => {
  const [insideArticleBody, setInsideArticleBody] = useState(false);
  const { anchorId, backgroundClass } = useHelpers(rendering);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const articleBody = document.querySelector('.abrdn-article-body');
      const accordion = document.querySelector('.accordion');
      if ((articleBody && articleBody.contains(accordion)) || articleBody) {
        setInsideArticleBody(true);
      }
    }
  }, []);
  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`accordion default-section-padding link-change ${backgroundClass}`}
    >
      <div className="container">
        <Placeholder
          rendering={rendering}
          name="abrdn-tiles-heading"
          className={`${insideArticleBody ? 'col-lg-12' : 'col-lg-8'} mb-4`}
        />
        <div className={`${insideArticleBody ? 'col-lg-12' : 'col-lg-8'}`}>
          {fields.items.map((item, index) => (
            <AccordionItem
              key={index}
              title={item.fields.title}
              description={item.fields.description}
              isFirst={rendering.params?.isFirst === '1' && index === 0}
              presentation={rendering.params?.presentation}
            >
              {item.fields.items && item.fields.items.length > 0 && (
                <AccordionItems items={item.fields.items} hideTitle={hideTitle} className="mt-3" />
              )}
            </AccordionItem>
          ))}
        </div>
      </div>
    </section>
  );
};

export default withDatasourceCheck()<AccordionProps>(Accordion);
